<template>
  <div class="pip-menu">
    <b-icon-arrow-up-right-square class="clickable" v-if="stylePipStatus==0 || stylePipStatus==4" @click="next" />
    <b-icon-arrow-down-right-square class="clickable" v-else-if="stylePipStatus==1" @click="next" />
    <b-icon-arrow-down-left-square class="clickable" v-else-if="stylePipStatus==2" @click="next" />
    <b-icon-arrow-up-left-square class="clickable" v-else-if="stylePipStatus==3" @click="next" />
    <b-icon-arrows-fullscreen class="ml-1 clickable" v-if="stylePipStatus!=0" @click.stop="fullScreen"/>
  </div>
</template>
<script>
import {
  BIconArrowDownLeftSquare,
  BIconArrowDownRightSquare,
  BIconArrowsFullscreen,
  BIconArrowUpRightSquare,
  BIconArrowUpLeftSquare,
} from "bootstrap-vue";

export default {
  name: "ColorsPipMenu",
  components: {
    BIconArrowDownRightSquare,
    BIconArrowUpRightSquare,
    BIconArrowDownLeftSquare,
    BIconArrowUpLeftSquare,
    BIconArrowsFullscreen,
  },
  methods: {
    // go to full screen mode
    fullScreen() {
      this.$store.dispatch('admin/updateStylePipStatus', 0);
      this.safeRouterPush("/colors");
    },
    // go to pip mode or to the next corner
    next() {
      let current = this.stylePipStatus;
      current++;
      if (current == 5) current = 1;
      this.$store.dispatch('admin/updateStylePipStatus', current);
      // if we're getting out of full screen mode, go to the home page
      if (this.$route.path === "/colors")
        this.safeRouterPush("/home");
    },
  },
  computed: {
    stylePipStatus() {
      return this.$store.getters['admin/stylePipStatus']
    }
  }
};
</script>
<style scoped>
.pip-menu {
  position: absolute;
  right: 0;
  top: 0;
}
</style>